import { sigteApiFetchChecked } from "./sigteUtils";

// Sube un archivo real (multipart) al staging de fotos (_pending/ en el
// servidor) y devuelve el filename que hay que guardar en el payload del
// dictamen. Usado para fotos de camara/galeria.
export async function subirFotoArchivo(file) {
  var fd = new FormData();
  fd.append("file", file);
  var body = await sigteApiFetchChecked("/fotos", { method: "POST", body: fd });
  return body.filename;
}

// Sube un data URL base64 (canvas.toDataURL() de una firma) al mismo
// staging. La firma es "solo otra foto" para el backend.
export async function subirFotoBase64(dataUrl) {
  var body = await sigteApiFetchChecked("/fotos", { method: "POST", body: JSON.stringify({ foto_base64: dataUrl }) });
  return body.filename;
}
